import { useStaticQuery, graphql } from 'gatsby'

export function useDataCompetenciesByEn() {
    const dataCompetencies = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageAbout(title: { eq: "Competencies: Title" }, locale: { eq: "en" }) {
                value
            }

            text: datoCmsRenshinPageAbout(title: { eq: "Competencies: Text" }, locale: { eq: "en" }) {
                value
            }

            heroImage: datoCmsRenshinPageAbout(title: { eq: "Competencies: Image" }, locale: { eq: "en" }) {
                image {
                    url
                }
            }

            items: allDatoCmsRenshinCompetencie(sort: { fields: [sorting], order: ASC }, filter: { locale: { eq: "en" } }) {
                nodes {
                    text
                    image {
                        url
                    }
                }
            }
        }
    `)

    return dataCompetencies
}
